<template>
<div :class=boxClass class="l_small" data-type="input" data-id="keywords" onclick="">
  <vue-autosuggest
  v-model="query"
  :suggestions="filteredOptions"
  :input-props="inputProps"
  :get-suggestion-value="getSuggestionValue"
  @input="onInputChange"
  @selected="findStores"
  >
    <template slot-scope="{suggestion}">
      {{ suggestion.item.sub }}, {{ suggestion.item.sta }}, {{ suggestion.item.pc }}
    </template>
  </vue-autosuggest>
  <button :class=submitClass @click="findStores">
    <svg class="icon"><use xlink:href="#search"></use></svg>
  </button>
</div>
</template>

<script>
import getDistance from 'geolib/es/getDistance';
import { VueAutosuggest } from 'vue-autosuggest';
import EventBus from '../utils/event-bus';
// import * as cities from '../cities.au.min.json';
// var suburbs = cities.default;
const queryString = require('query-string');

export default {
  name: "Finder",
  data() {
    return {

      stores: [],

      query: '',

      hasResults: false,

      isEmpty: false,

      isLoading: false,

      errors: [],

      localStores: [],

      suggestions: [],

      filteredSuggestions: [],

      inputProps: {
        placeholder: this.placeholder,
        class: this.inputClass
      }

    };
  },
  props: {
    apikey: String,
    searchId: String,
    boxClass: {
      type: String,
      default: 'filter'
    },
    inputClass: {
      type: String,
      default: 'filter-input'
    },
    submitClass: {
      type: String,
      default: 'filter-submit'
    },
    placeholder: {
      type: String,
      default: 'Enter suburb or postcode'
    }
  },
  components: {
    VueAutosuggest
  },
  computed: {

    filteredOptions() {
      if (this.suggestions) {
        return [
          {
            data: this.suggestions.filter(option => {
              if (this.query.length > 2) {
                var test = option.pc.toString() + ' ' + option.sub.toString();
                return test.toLowerCase().indexOf(this.query.toLowerCase()) > -1;
              } else {
                return false;
              }
            })
          }
        ];
      } else {
        return [];
      }
    }

  },
  methods: {

    findStores(suggestion) {

      var address = this.query;
      if (typeof suggestion !== 'undefined' && typeof suggestion == 'object' && suggestion !== null) {
        if (typeof suggestion.item !== 'undefined') {
          address = this.getSuggestionValue(suggestion);
        }
      }

      // console.log(address);

      if (this.boxClass == 'searchfield') {
        window.location.href = '/stores/?s=' + encodeURI(address);
        return false;
      }

      var API_KEY = 'AIzaSyBlsOcGI7QWt0TPXXyxS6GVlbA1BpsKG6o';

      this.errors = [];
      this.isLoading = true;
      EventBus.$emit('MAP_LOADING', this.searchId);

      var localStores = [];

      var lat;
      var lng;
      // fetch("https://maps.googleapis.com/maps/api/geocode/json?region=au&address="+address+"&key="+API_KEY)
      //   .then(response => response.json())
      //   .then(data => {
    
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode( { address: address }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          
          this.errors.splice(0);
      
          // get lat and lng
          lat = results[0].geometry.location.lat();
          lng = results[0].geometry.location.lng();

          this.stores.forEach(function(store) {
            var dist = getDistance(
                { latitude: lat, longitude: lng },
                { latitude: store.lat, longitude: store.lng }
            );
            dist = dist / 1000; // convert to kms
            if (dist < 50) {
              store.distance = dist.toFixed(2);
              localStores.push(store);
            }
          });
          this.isLoading = false;

          localStores.sort(function(a, b) {
              return a.distance - b.distance;
          });

          if (localStores.length) {
            this.hasResults = true;
            this.isEmpty = false;
            this.localStores = localStores;

            EventBus.$emit('MAP_POPULATE', this.searchId, localStores);

          } else {
            this.hasResults = false;
            this.isEmpty = true;
            this.localStores = [];

            EventBus.$emit('MAP_POPULATE', this.searchId, []);
          }
          
        }
      });

    },

    displayStore(store) {

      EventBus.$emit('STORE_DISPLAY', this.searchId, store);

      return false;

    },

    onInputChange(text) {
    },

    onInputClick() {
      this.$refs.finderInput.select();
    },

    getSuggestionValue(suggestion) {
      if (typeof suggestion !== 'undefined' && suggestion !== null) {
        return suggestion.item.sub + ', ' + suggestion.item.sta + ', ' + suggestion.item.pc;
      } else {
        return '';
      }
    },

  },
  mounted() {

    EventBus.$on('LOAD_CITIES', (cities) => {
      this.suggestions = cities;
    });

    // get stores array
    if (typeof window.stores !== 'undefined') {
      this.stores = window.stores;
      // console.log(this.stores);
    }

    const parsed = queryString.parse(location.search);
    if (typeof parsed.s !== 'undefined') {
      if (parsed.s.length) {
        this.query = parsed.s;
        this.findStores();
      }
    }

  }
};
</script>

<style scoped>
</style>